export interface IUnderwriterDataUI {
  name: string;
  websiteURL: string;
}
export const constructNewUnderwriterDataUI = ({
  name = 'Underwriter',
  websiteURL = '',
}: Partial<IUnderwriterDataUI> = {}): IUnderwriterDataUI => ({ name, websiteURL });
